import { schemeTableau10 } from "d3";

const colors = schemeTableau10;

export default colors;
